module.exports = __webpack_public_path__ + "static/media/water-tc.1cb211f0.svg";